import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout';
import { Card } from '../../components/ui/card';
import { Loader2, Building2, Search } from 'lucide-react';
import api from '../../utils/api';
import { toast } from 'sonner';
import MidTermSection from './MidTermSection';

export default function MidTermListPage() {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState('');
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    api.get('/mid-term/properties')
      .then(res => {
        setProperties(res.data.properties || []);
        if ((res.data.properties || []).length === 1) setSelected(res.data.properties[0]);
      })
      .catch(err => toast.error(err.response?.data?.detail || 'Errore nel caricamento'))
      .finally(() => setLoading(false));
  }, []);

  const filtered = properties.filter(p =>
    !query || `${p.name} ${p.property_code} ${p.city}`.toLowerCase().includes(query.toLowerCase()));

  return (
    <div className="p-6 max-w-6xl mx-auto space-y-4" data-testid="midterm-list-page">
      <div>
        <h1 className="text-xl font-bold text-slate-800">Medio Termine</h1>
        <p className="text-sm text-slate-500">Prezzi mensili per soggiorni di 60+ notti — immobili con Medio Termine attivo</p>
      </div>
      {loading ? (
        <div className="py-16 text-center"><Loader2 className="h-6 w-6 animate-spin mx-auto text-slate-400" /></div>
      ) : properties.length === 0 ? (
        <Card className="p-8 text-center text-slate-400 text-sm" data-testid="midterm-list-empty">
          <Building2 className="h-8 w-8 mx-auto mb-2" />
          Nessun immobile ha il flag "Medio termine" attivo. Il flag si imposta dalla scheda immobile (tab Presentazione).
        </Card>
      ) : (
        <>
          <div className="relative max-w-sm">
            <Search className="h-4 w-4 absolute left-3 top-2.5 text-slate-400" />
            <input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Cerca immobile..."
              className="w-full pl-9 pr-3 py-2 border rounded-lg text-sm" data-testid="midterm-list-search" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
            {filtered.map(p => (
              <button key={p.id} onClick={() => setSelected(p)}
                className={`text-left border rounded-lg px-3 py-2.5 text-sm transition-colors ${selected?.id === p.id ? 'border-blue-500 bg-blue-50' : 'hover:bg-slate-50'}`}
                data-testid={`midterm-list-item-${p.property_code}`}>
                <span className="font-medium block">{p.name}</span>
                <span className="text-xs text-slate-500">{p.property_code} · {p.city} {p.calendar ? `· ${p.calendar}` : ''}</span>
              </button>
            ))}
          </div>
          {selected && (
            <MidTermSection key={selected.id} propertyId={selected.id} pub={{}} setPubField={() => {}}
              canEdit={false} dirty={false} isAdmin={false} />
          )}
        </>
      )}
    </div>
  );
}
